import React from "react";
import { useNavigate } from "react-router-dom";
import { Updater } from "use-immer";

import { IgLink, IgTypography } from "@intelligems/ig-theme";
import { CustomEventFeType } from "@intelligems/ig-types";
import { Grid, useTheme } from "@mui/material";
import { CustomEventFeList } from "@src/features/customEvents/components/CustomEventFeList";
import { GENERAL_ROUTES } from "@src/routes/routes";

interface CreateEventPageProps {
  setSubpageSelected: (subpage: CustomEventFeType) => void;
  isCreating: boolean;
  subpageSelected: CustomEventFeType | null;
  setDrawerPage: Updater<string>;
  handleClose?: () => void;
}

export const CreateCustomEvent = ({
  setSubpageSelected,
  isCreating,
  subpageSelected,
  setDrawerPage,
  handleClose,
}: CreateEventPageProps) => {
  const navigate = useNavigate();
  const theme = useTheme();
  if (isCreating && !subpageSelected) {
    return (
      <Grid container width={"100%"} rowSpacing={4}>
        <Grid item>
          <IgTypography fontWeight={600} variant={"h2"}>
            What kind of visitor behavior do you want to track?
          </IgTypography>
        </Grid>
        <Grid item>
          <IgTypography color={theme.palette.text.secondary}>
            Choose an event below. Once created, you'll be able to track your
            event across your tests. You can later monitor, archive, and edit in
            the{" "}
          </IgTypography>
          <IgLink
            onClick={() => {
              if (handleClose) {
                handleClose();
              }
              void navigate(GENERAL_ROUTES.EventsManager);
            }}
          >
            Events Manager.
          </IgLink>
        </Grid>
        <Grid item>
          <CustomEventFeList
            setSubpageSelected={setSubpageSelected}
            setDrawerPage={setDrawerPage}
          />
        </Grid>
      </Grid>
    );
  }
  return null;
};
